var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusIcon = function SvgStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2999_478)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75298 12.5C4.68191 12.5017 3.00432 14.1819 3.00598 16.253C3.00764 18.3241 4.68791 20.0017 6.75898 20C8.82888 19.9984 10.506 18.3199 10.506 16.25C10.506 14.1784 8.8266 12.5 6.75498 12.5C6.75465 12.5 6.75332 12.5 6.75298 12.5ZM17.247 12.5C15.1759 12.5017 13.4983 14.1819 13.5 16.253C13.5016 18.3241 15.1819 20.0017 17.253 20C19.3229 19.9984 21 18.3199 21 16.25C21 14.1784 19.3206 12.5 17.249 12.5C17.2486 12.5 17.2473 12.5 17.247 12.5ZM12 3.42401C9.92891 3.42567 8.25132 5.10594 8.25298 7.17701C8.25464 9.24808 9.93491 10.9257 12.006 10.924C14.0759 10.9224 15.753 9.24391 15.753 7.17401C15.753 5.10239 14.0736 3.42401 12.002 3.42401C12.0016 3.42401 12.0003 3.42401 12 3.42401Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2999_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgStatusIcon as ReactComponent };
export default __webpack_public_path__ + "status-icon.svg";